import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { usePopup } from '../../context/PopupContext';
import { saveResume, PREVIEW_RESUME } from '../../services/actions/actions';
import { getDateTime } from '../../helper';

const RenamePopup = (props) => {
    const dispatch = useDispatch();
    const { boxContent, close, status, rightCallbackAction, leftCallbackAction, data, waiting, setWaiting } = usePopup();
    const [newResumeName, setNewResumeName] = useState('');

    const getResumeName = () => {
        let resumeName = '';
        if (window.location.pathname === '/') {
            resumeName = localStorage.getItem('resumeName');
        } else {
            const fullname = (
                data.resume.heading.fname != ""
                    ? data.resume.heading.fname +
                    (
                        data.resume.heading.lname != ""
                            ? "_" + data.resume.heading.lname
                            : ''
                    )
                    : "Resume_Draft"
            );
            resumeName = (
                (data.resume.hasOwnProperty('resume_name')
                    && data.resume.resume_name != '')
                    ? data.resume.resume_name
                    : fullname.replace(/\s/g, "_")
            );
        }
        setNewResumeName(resumeName);
    }

    const saveName = () => {
        dispatch(
            saveResume(
                {
                    resume_name: newResumeName, 
                    modified_date: getDateTime()
                },
                PREVIEW_RESUME, 
                true
            )
        );
    }

    const changeResumeName = (e) => {
        setNewResumeName(e.target.value);
    }

    const ref = useRef(null);

    const getName = () => {
        if(!ref.current || ref.current != data.resume.id){
            ref.current = data.resume.id;
            getResumeName();
        }
    }
    
    if(status('renamebox')) getName();

    return (<>
        {status('renamebox') && <><div className="transparent-popup-bg"></div>
            <div className="custom-skip-popup">
                <div className="close-btn-icon">
                    <button className="close-icon"
                        onClick={() => {
                            close();
                        }}>Close</button>
                </div>
                <div className="content-box">
                    <h4>Enter a Name</h4>
                    <div className="download-icons-area rename-input">
                        <input 
                            id="resume_name" 
                            type="text" 
                            name="resume_name" 
                            value={newResumeName} 
                            onChange={(e) => changeResumeName(e)}
                        />
                    </div>
                    <div className="button-area">
                        <button className="no-skip" onClick={() => {
                            leftCallbackAction();
                        }}>Cancel</button>
                        <button className="skip" onClick={() => {
                            saveName();
                            rightCallbackAction();
                        }}>Save</button>
                    </div>
                </div>
            </div></>}
    </>)
}
export default RenamePopup;

